(function () {
  'use strict';

  var script = document.currentScript;
  var fallbackSrc = script && script.getAttribute('data-fallback-src');
  var selector = [
    'img.jdgm-carousel-item__product-image',
    'img.jdgm-rev__pic-img',
    '.jdgm-carousel-item__product-image img',
    '.jdgm-rev__pic-img img'
  ].join(',');

  if (!fallbackSrc) return;

  function isReviewImage(image) {
    return image && image.nodeType === 1 && image.matches(selector);
  }

  function installFallback(image) {
    if (!isReviewImage(image) || image.dataset.ssReviewFallback === 'true') return;

    image.dataset.ssReviewFallback = 'true';
    image.classList.add('ss-review-image-fallback');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.alt = 'Sacred Surreal';
    image.src = fallbackSrc;
  }

  function scan(root) {
    if (root.nodeType === 1 && isReviewImage(root)) {
      if ((root.currentSrc || root.getAttribute('src')) && root.complete && root.naturalWidth === 0) {
        installFallback(root);
      }
    }

    if (!root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach(function (image) {
      if ((image.currentSrc || image.getAttribute('src')) && image.complete && image.naturalWidth === 0) {
        installFallback(image);
      }
    });
  }

  document.addEventListener('error', function (event) {
    installFallback(event.target);
  }, true);

  function start() {
    window.setTimeout(function () { scan(document); }, 5000);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          window.setTimeout(function () { scan(node); }, 3000);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
